
import { Component, Vue } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import FilterModule from "../../store/modules/FilterModule";
import ContentModule from "@/store/modules/ContentModule";
import CategoryList from "@/components/CategoryList/CategoryList.vue";
import FilterNewsToggle from "@/components/FilterNewsToggle/FilterNewsToggle.vue";
import TopicList from "@/components/TopicList/TopicList.vue";
import SearchInput from "@/components/SearchInput/SearchInput.vue";

import $ from "jquery";

@Component({
  components: {
    SearchInput,
    CategoryList,
    FilterNewsToggle,
    TopicList,
  },
})
export default class Submenu extends Vue {
  private readonly filterModule = getModule(FilterModule, this.$store);
  private readonly contentModule = getModule(ContentModule, this.$store);

  private sticky = false;
  private subMenuOffset = 0;

  private get breadcrumbOutput() {
    let filters = [];

    if (this.filterModule.market) {
      const localizedTitle = this.$t.getLocalizedFilterString(this.filterModule.market.entry);
      filters.push(`<strong>${localizedTitle}</strong>`);
    }
    if (this.filterModule.model) {
      filters.push(`<strong>${this.filterModule.model.entry}</strong>`);
    }
    if (this.filterModule.structureWeek) {
      filters.push(`<strong>${this.filterModule.structureWeek.entry}</strong>`);
    }
    if (this.filterModule.propulsion) {
      const localizedTitle = this.$t.getLocalizedFilterString(this.filterModule.propulsion.entry);
      filters.push(`<strong>${localizedTitle}</strong>`);
    }
    if (this.filterModule.electricCapacity) {
      filters.push(`<strong>${this.filterModule.electricCapacity.entry}</strong>`);
    }
    if (this.filterModule.electricPowertrain) {
      filters.push(`<strong>${this.filterModule.electricPowertrain.entry}</strong>`);
    }

    return filters.join(" / ");
  }

  private get locale() {
    return this.contentModule.locale;
  }

  private setSticky() {
    const $topmenu = $(".top-nav");
    const $langSel = $(".language-selector");

    this.subMenuOffset = $topmenu.length ? ($topmenu.height() as number) : 0;
    this.sticky = window.pageYOffset > this.subMenuOffset;
    if (this.sticky) {
      $("body").addClass("submenu-fixed");
      // Temporary fix to close language selector on scroll
      if ($langSel.length && $langSel.hasClass("open")) $langSel.removeClass("open");
    } else {
      $("body").removeClass("submenu-fixed");
    }
  }

  private initiate() {
    window.addEventListener("scroll", this.setSticky);
    this.setSticky();
  }

  created() {
    this.initiate();
  }
}
